import React, { useState, useMemo, useContext } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { SnackbarProvider } from 'notistack';
import {
  ThemeProvider,
  createTheme,
  useTheme
} from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  IconButton,
  Button
} from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useSelector } from 'react-redux';

// Create a context for theme toggling
export const ColorModeContext = React.createContext({
  toggleColorMode: () => { },
  mode: 'dark'
});

// Comprehensive color palette
const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
        // Light mode palette
        primary: {
          main: '#1976d2',
          light: '#4791db',
          dark: '#115293'
        },
        background: {
          default: '#f4f4f4',
          paper: '#ffffff'
        },
        text: {
          primary: '#000000',
          secondary: '#333333'
        },
        buy: {
          main: '#4CAF50',
          light: '#81c784',
          dark: '#388e3c',
          background: '#0FC18C1F'
        },
        sell: {
          main: '#f44336',
          light: '#e57373',
          dark: '#d32f2f',
          background: '#DE201C1F'
        }
      }
      : {
        // Dark mode palette
        primary: {
          main: '#00FFD1',
          light: '#69FFDB',
          dark: '#00BFA5'
        },
        background: {
          default: '#0F1429',
          paper: '#1A2138'
        },
        text: {
          primary: '#E0F7FA',
          secondary: '#B0BEC5'
        },
        buy: {
          main: '#2E7D32',
          light: '#4CAF50',
          dark: '#1B5E20',
          background: '#0FC18C1F'
        },
        sell: {
          main: '#B71C1C',
          light: '#D32F2F',
          dark: '#8B0000',
          background: '#DE201C1F'
        }
      }
    )
  },
  typography: {
    fontFamily: [
      'Space Grotesk',
      'system-ui',
      'sans-serif'
    ].join(','),
    h1: {
      fontFamily: 'Space Grotesk',
      fontWeight: 700,
      letterSpacing: '-1px'
    },
    body1: {
      fontFamily: 'Space Grotesk',
      fontWeight: 400
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
      `
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Space Grotesk',
          textTransform: 'none',
          borderRadius: 8
        }
      }
    }
  }
});



function AppWithTheme() {
  const themeMode = useSelector(state => state.theme.mode);
  const theme = useMemo(() => createTheme(getDesignTokens(themeMode)), [themeMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <AppWithTheme />
        </SnackbarProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);




